module.exports = __webpack_public_path__ + "img/profile_bg.fbe0b561.svg";